import { useTranslation } from "react-i18next";
import { App } from "antd";

import { useDownloadModuleResourcesMutation } from "@/redux/service";
import { UseResourceDownloadOptions } from "@/features/certifications/module/types";

export const useResourceDownload = ({
  moduleId,
  certificationSlug,
  onDownloaded,
}: UseResourceDownloadOptions) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const [download, { isLoading, originalArgs }] =
    useDownloadModuleResourcesMutation();

  const handleDownload = async (contentItemId: number) => {
    try {
      const [file] = await download({
        moduleId,
        certificationSlug,
        contentItems: [contentItemId],
      }).unwrap();
      if (!file) {
        throw new Error("No file to download");
      }
      window.location.assign(file.url);
      onDownloaded?.(contentItemId);
    } catch {
      notification.error({
        message: t("certification.module.resources.downloadError"),
      });
    }
  };

  return {
    handleDownload,
    isBusy: isLoading,
    downloadingId: isLoading ? originalArgs?.contentItems[0] : undefined,
  };
};
